<template>
  <div id="app"
       v-loading="loading"
       element-loading-text="読み込み中"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(255, 255, 255, 1)">
    <router-view/>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    computed: {
      ...mapGetters([
        'loading'
      ])
    },
    name: 'App'
  }
</script>



// WEBPACK FOOTER //
// src/App.vue